import Lookup from 'src/componentes/select-async';
import DicionarioRiscoView from 'src/paginas/gestao-risco/DicionarioRiscos';

const CategoriaDicionarioRiscoLookup = ({ ...rest }) => {
  const construirCaminho = (cat) => {
    const caminho = [];
    let atual = cat;

    while (atual) {
      caminho.unshift(atual);
      atual = atual.pai;
    }

    return caminho;
  };

  const optionRenderer = (item) => {
    const optionId = `FUNCAO-FORMULA-LIFTBOX-${item.id}-0000001`;
    const caminho = construirCaminho(item);
    return (
      item && (
        <>
          <div className="font-weight-bolder d-flex justify-content-between" id={optionId}>
            <div>{item.nome}</div><div>{`N${item.nivel}`}</div>
          </div>
          <div className="text-muted text-sm" id={optionId}>
            {caminho.map((cat, index) => (
              <span key={cat.id}>
                {index > 0 && <span> / </span>}
                <span>
                  {cat.nome}
                </span>
              </span>
            ))}
          </div>
        </>
      )
    );
  };

  return (
    <Lookup
      labelKey="nome"
      valueKey="id"
      url="/DicionarioRiscoLookup"
      clearable={false}
      showSearch={true}
      showNew={false}
      searchComponent={DicionarioRiscoView}
      optionRenderer={optionRenderer}
      {...rest}
    />
  );
};

export default CategoriaDicionarioRiscoLookup;
